import { FC } from "react";
import { observer } from "mobx-react-lite";
import { SessionsListPageList } from "./components/SessionsListPageList";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { FadeBottom } from "@/components/horizontal-scroll/FadeBottom";
import { SessionsListPageHeader } from "./components/SessionsListPageHeader";
import { MdsPanelContainer } from "@/design-system/components/panel";
import { useTabPageStore } from "@/hooks/useTabPageStore";

interface SessionsListPageProps {}

export const SessionsListPage: FC<SessionsListPageProps> = observer(() => {
  const page = useTabPageStore("sessionsListPage");

  useEffectOnMount(() => {
    page.resetState();
  });

  return (
    <>
      <SessionsListPageHeader />
      <MdsPanelContainer>
        <SessionsListPageList />
        <FadeBottom />
      </MdsPanelContainer>
    </>
  );
});
